import * as React from 'react'
import { IntercomProvider } from 'react-use-intercom'

import { Intercom } from './components/Intercom/Intercom'
import { ScrollToTop } from './components/ScrollToTop/ScrollToTop'
import { Snackbars } from './components/Snackbars/Snackbars'
import { StripeTosModal } from './components/StripeTos/StripeTosModal'
import { getIntercomAppId } from './config/config'
import { Consultant } from './pages/Consultant/Consultant'
import { Routes } from './Routes'

export const AppContainer = ({ children }: { children?: React.ReactNode }) => {
  return (
    <IntercomProvider appId={getIntercomAppId()}>
      <Intercom>
        {children ? children : <Routes />}
        <Snackbars />
        <ScrollToTop />
        <StripeTosModal />
        <Consultant />
      </Intercom>
    </IntercomProvider>
  )
}
